import { render, staticRenderFns } from "./Form.vue?vue&type=template&id=d4eca1c8"
import script from "./Form.vue?vue&type=script&lang=js"
export * from "./Form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d4eca1c8')) {
      api.createRecord('d4eca1c8', component.options)
    } else {
      api.reload('d4eca1c8', component.options)
    }
    module.hot.accept("./Form.vue?vue&type=template&id=d4eca1c8", function () {
      api.rerender('d4eca1c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/design/ui-components/goodslist/Form.vue"
export default component.exports